import React from "react";
import { Badge, Box, Button, Card, Grid, Icon, Link, Modal, Progress, Text } from "~/components-shared";
import styled from "styled-components";
import { RoutesEnum } from "~/types/enums";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledLink = styled(Link)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const TopicContributionsCard = _ref => {
  let {
    widget,
    ...rest
  } = _ref;
  const {
    previous,
    current
  } = widget.data;
  const [open, setOpen] = React.useState(false);
  const currentTotalCount = current.byTopic.reduce((p, c) => p + c.count, 0);
  const previousTotalCount = previous.byTopic.reduce((p, c) => p + c.count, 0);
  const deltaPercentage = previousTotalCount === 0 ? 0 : (currentTotalCount - previousTotalCount) / previousTotalCount * 100;
  const cardItem = topic => {
    const currentTopicCount = topic.count;
    const previousTopicCount = previous.byTopic.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === topic.id;
    })?.count || 0;
    const topicDeltaPercentage = previousTopicCount === 0 ? 0 : (currentTopicCount - previousTopicCount) / previousTopicCount * 100;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLink, {
      href: RoutesEnum.TOPIC.replace(":topicId", topic.id),
      color: "text",
      fontSize: 4
    }, topic.name), /*#__PURE__*/React.createElement(Progress, {
      values: [(currentTopicCount / currentTotalCount || 1) * 100],
      labels: [`${currentTopicCount}`],
      height: 2
    }), /*#__PURE__*/React.createElement(Grid.Cell, {
      align: "start"
    }, /*#__PURE__*/React.createElement(Badge, {
      s: {
        py: 0
      },
      color: topicDeltaPercentage === 0 ? "translucent" : topicDeltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
    }, topicDeltaPercentage === 0 ? "-" : `${topicDeltaPercentage > 0 ? "+" : ""}${topicDeltaPercentage.toFixed(0)}%`)));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Box, {
    align: "end",
    s: {
      mb: 5
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 15,
    lineHeight: 15
  }, currentTotalCount), /*#__PURE__*/React.createElement(Text, {
    element: "h5",
    fontSize: 5,
    lineHeight: 6,
    weight: "semiBold",
    display: "inline"
  }, "TOPIC", /*#__PURE__*/React.createElement("br", null), "CONTRIBUTIONS")), /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr minmax(100px, 30%) auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    weight: "semiBold"
  }, "Total"), /*#__PURE__*/React.createElement(Progress, {
    values: [100],
    labels: [`${currentTotalCount}`],
    height: 2,
    s: {
      mb: 0.5
    }
  }), /*#__PURE__*/React.createElement(Grid.Cell, {
    align: "start"
  }, /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0
    },
    color: deltaPercentage === 0 ? "translucent" : deltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
  }, deltaPercentage === 0 ? "-" : `${deltaPercentage > 0 ? "+" : ""}${deltaPercentage.toFixed(0)}%`)), current.byTopic.slice(0, 5).map(topic => cardItem(topic))), current.byTopic.length > 5 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 5
    }
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: () => setOpen(true),
    color: "primary",
    fontSize: 4
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Footprints distribution by Topics",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Topic Contributions Items",
    onClose: () => setOpen(false),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr minmax(100px, 30%) auto",
    align: "center",
    gap: 4,
    s: {
      mt: 3
    }
  }, current.byTopic.map(item => cardItem(item)))))));
};
export default TopicContributionsCard;